module.exports = __webpack_public_path__ + "update-userdata-ilustration.svg";